module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Impact preferences\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('SuccessAlert', {
    attrs: {
      "isVisible": _vm.isSuccessMessageVisible,
      "message": _vm.successMessage
    },
    on: {
      "hideSuccessAlert": _vm.hideSuccessMessage
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb-lg"
  }, [(_vm.activeAccountId !== null) ? _c('preferences', {
    attrs: {
      "account-id": _vm.activeAccountId,
      "primaryInvestor": _vm.user
    },
    on: {
      "saved": _vm.onPreferencesSaved,
      "loaded": _vm.onPreferencesLoaded
    }
  }) : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "panel-title mt-xl mb-lg"
  }, [_c('p', [_vm._v("You can target your account balance to one or more portfolio sectors and\n          initiatives below. We use this to inform our portfolio deployment and impact in line with investor interests. This is optional, and does not change the risk or any\n          characteristics of your investments. Please refer to the\n          "), _c('strong', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.calvertimpactcapital.org/prospectus"
    }
  }, [_vm._v("prospectus")])]), _vm._v(" for more information.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d059d964","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorPreferences.vue
// module id = 2205
// module chunks = 1